// @flow

import _ from 'lodash';
import type {
  AvailableCollectionsState,
  AvailableCollectionsAction
} from 'stores/flow-type/collection.type';

import {
  GET_AVAILABLE_COLLECTIONS_REQUEST,
  GET_AVAILABLE_COLLECTIONS_SUCCESS,
  GET_AVAILABLE_COLLECTIONS_FAILURE,
  GET_ALL_COLLECTIONS_REQUEST,
  GET_ALL_COLLECTIONS_SUCCESS,
  GET_ALL_COLLECTIONS_FAILURE
} from 'stores/flow-type/filter-tree/collection.type';

const initialState: AvailableCollectionsState = {
  loading: false,
  success: false,
  error: undefined,
  availableCollections: [],
  allCollections: []
};

const availableCollectionsReducers = (
  state: AvailableCollectionsState = initialState,
  action: AvailableCollectionsAction
) => {
  switch (action.type) {
    case GET_AVAILABLE_COLLECTIONS_REQUEST:
      return { ...state, loading: true, success: false };
    case GET_AVAILABLE_COLLECTIONS_SUCCESS: {
      let { data: availableCollections } = action.payload.data;

      if (availableCollections) {
        availableCollections = _.map(availableCollections, item => ({
          value: item.id,
          label: item.title,
          handle: item.handle
        }));
      }

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        availableCollections
      };
    }
    case GET_AVAILABLE_COLLECTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    case GET_ALL_COLLECTIONS_REQUEST:
      return { ...state, loading: true, success: false };
    case GET_ALL_COLLECTIONS_SUCCESS: {
      let { data: allCollections } = action.payload.data;

      if (allCollections) {
        allCollections = _.map(allCollections, item => ({
          value: item.id,
          label: item.title,
          handle: item.handle
        }));
      }

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        allCollections
      };
    }
    case GET_ALL_COLLECTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
};
export default availableCollectionsReducers;
